<div class="form-preview-wrapper">
    <div *ngIf="isLoading" class="loading-overlay center-loader">
        <p-progressSpinner [style]="{height: '50px', width: '50px'}" strokeWidth="4" animationDuration="0.5s"></p-progressSpinner>
    </div>

    <div *ngIf="stateEmpty" class="error-state">
        <div class="error-content">
            <div class="error-icon">
                <i class="pi pi-info-circle"></i>
            </div>
            <h2>No Form to Preview</h2>
            <div class="empty-state-message">
                <p>There is no form data available for preview.</p>
                <p>Please make sure you have:</p>
                <ul>
                    <li>Added sections to your form</li>
                    <li>Added fields to the sections</li>
                    <li>Specified form name and other required information</li>
                </ul>
            </div>
            <div class="action-buttons">
                <button pButton label="Back to Form Builder" class="p-button-primary" (click)="backToEdit()"></button>
            </div>
        </div>
    </div>

    <div *ngIf="errorType" class="error-state">
        <div class="error-content">
            <div class="error-icon">
                <i [ngClass]="'pi pi-info-circle'"></i>
            </div>
            <h2>
                <ng-container *ngIf="errorType === 'not-found'">Form Not Found</ng-container>
                <ng-container *ngIf="errorType === 'server-error'">Server Error</ng-container>
                <ng-container *ngIf="errorType === 'invalid-uuid'">Invalid Form ID</ng-container>
            </h2>
            <div class="error-message">{{ errorMessage }}</div>
            <div class="action-buttons">
                <button pButton label="Back to Forms List" class="p-button-primary" (click)="backToForms()"></button>
            </div>
        </div>
    </div>

    <div class="test" *ngIf="!isLoading && !stateEmpty && !errorType && formData">
        <div *ngIf="headerContent" class="footer">
            <p [innerHTML]="headerContent"></p>
        </div>
        
        <div class="logo">
            <img class="logo-img" [src]="formLogo" alt="Form Logo">
        </div>
        
        <div *ngIf="formCoverImage" 
            class="banner"
            [style]="{backgroundColor: formType == 'registration' ? '#18C76F' : formType == 'documentation' ? '#115C36' : formName == 'offer' ? '#18C76F' : '#FFFFFF'}">
            <img class="banner-image" [src]="formCoverImage" alt="Cover Image">
        </div>
        
        <div style="display:flex; justify-content:center">
            <div style="max-width: 1140px; padding: 0 10vw; margin-bottom: 30px;">
                <div class="form-data" [ngClass]="{'widthAdject': (formType ==='documentation')}">
                    <h2 *ngIf="formType ==='documentation'" class="form-title">Additional Questionnaire and Documents Submission Form</h2>
                    <h2 *ngIf="formType !=='documentation'" class="form-title">{{formType | titlecase}} Form</h2>
                </div>

                <div class="warning-msg" *ngIf="formType ==='documentation'" 
                    style="background-color: #fff3cd; color: #856404; padding: 10px; border: 1px solid #ffeeba; border-radius: 4px; margin: 0 20px;">
                    <strong>Note:</strong> This is a preview. Fields are in read-only mode.
                </div>

                <div *ngFor="let section of templateCollections">
                    <div class="personal-info">
                        <div>
                            <h3 class="personal-details_label">{{section[0].displaySection}}</h3>
                            <hr class="title-line">
                        </div>
                        <div *ngFor="let model of section">
                            <app-fields 
                                [model]="model"
                                [clicked]="false"
                                [invalidField]="false"
                                [inValidLocation]="false"
                                [belowAge]="false"
                                [duplicateData]="false"
                                [inEditMode]="true"
                                [ansChange]="false"
                                [verifyByEmail]="false"
                                [p1EmailVerified]="true"
                                [p1MobileVerified]="false"
                                [enableMobile]="false">
                            </app-fields>
                        </div>
                    </div>
                </div>

                <button pButton pRipple 
                        type="button" 
                        label="Submit" 
                        class="form-btn"
                        disabled>
                </button>
            </div>
        </div>

        <div *ngIf="footerContent" class="footer">
            <p [innerHTML]="footerContent"></p>
        </div>
    </div>
</div>

<p-toast></p-toast>
